<div class="cipo--height--full cipo--position--relative" fxLayout="column" fxLayoutAlign="space-between">
    <div fxLayout="column" class="p-t-md p-a-md" fxFlex="grow">
        <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="16px">
            <div class="assignment-total">
                @if (userAllocationEnabled() && hasUpdate && assignments().length) {
                    <span class="cipo--text-weight--bold">
                        {{ "assignments.totalAllocation" | translate }}: {{ totalAllocationHours() }}
                        {{ "assignments.hoursPerMonth" | translate }}
                    </span>
                }
            </div>
            <div fxLayout fxLayoutAlign="end center">
                @if ((moduleId == MODULE_IDS.Program || moduleId == MODULE_IDS.Project) && anyAssignmentsChanged()) {
                    <mat-checkbox
                        [disabled]="loading() || disabledForm()"
                        [checked]="propagateHierarchy()"
                        (change)="propagateHierarchy.set($event.checked)"
                        class="m-r-sm">
                        {{ "assignments.propagateHierarchy" | translate }}
                    </mat-checkbox>
                }
                <button
                    mat-button
                    (click)="openSelectUsersModel()"
                    class="m-r-sm"
                    [disabled]="loading() || disabledForm()">
                    <mat-icon>group_add</mat-icon>
                    {{ "assignments.assignment" | translate }}
                </button>
                <button
                    mat-button
                    (click)="openPrimaryUsersModel()"
                    class="m-r-sm"
                    [disabled]="loading() || disabledForm()">
                    <mat-icon>person_check</mat-icon>
                    {{ "assignments.setPrimaryUsers" | translate }}
                </button>
                <button
                    mat-icon-button
                    (click)="loadData()"
                    class="m-r-sm"
                    [attr.aria-label]="'a11y.common.refresh' | translate"
                    [disabled]="loading() || disabledForm()">
                    <mat-icon aria-hidden="true">refresh</mat-icon>
                </button>
                <mat-form-field class="cipo-input p-0">
                    <mat-label>{{ "assignments.search" | translate }}</mat-label>
                    <input
                        [readonly]="loading() || this.ordering() || this.saving()"
                        matInput
                        [formControl]="searchControl" />
                    @if (searchControl.value) {
                        <button
                            matSuffix
                            [title]="'assignments.clear' | translate"
                            [attr.aria-label]="'assignments.clear' | translate"
                            mat-icon-button
                            (click)="clearInput()"
                            [disabled]="loading() || this.ordering() || this.saving()">
                            <mat-icon aria-hidden="true">close</mat-icon>
                        </button>
                    } @else {
                        <button
                            matSuffix
                            [title]="'assignments.search' | translate"
                            [attr.aria-label]="'assignments.search' | translate"
                            mat-icon-button
                            [disabled]="loading() || this.ordering() || this.saving()">
                            <mat-icon aria-hidden="true">search</mat-icon>
                        </button>
                    }
                </mat-form-field>
            </div>
        </div>
        <div class="m-t assignments-list-container" fxFlex="grow">
            @if (loading()) {
                <div fxLayoutAlign="center center">
                    <mat-spinner></mat-spinner>
                </div>
            } @else {
                @if (!assignments()?.length) {
                    <h4 fxLayout fxLayoutAlign="center center" class="m-t-xxl">
                        {{ "assignments.noAssignments" | translate }}
                    </h4>
                } @else {
                    <cdk-virtual-scroll-viewport
                        cipoKeyboardList
                        [itemSize]="85"
                        appendOnly
                        [minBufferPx]="850"
                        [maxBufferPx]="1700"
                        class="assignments-viewport"
                        [ariaLabel]="'assignments.assignment' | translate"
                        [itemCount]="initialSearchAssignments().length">
                        <div
                            *cdkVirtualFor="
                                let assignment of initialSearchAssignments();
                                trackBy: virtualTrackBy;
                                let i = index
                            "
                            tabindex="-1"
                            [attr.data-list-index]="i"
                            class="assignment-row cipo--border-bottom--lite p-x-sm"
                            [class.cipo--border--solid]="assignment.deleting || assignment.edited || assignment.isNew"
                            [class.cipo--border-color--accent]="
                                assignment.deleting || assignment.edited || assignment.isNew
                            "
                            fxLayout
                            fxLayoutAlign="start center"
                            fxLayoutGap="16px">
                            <div class="assignment-details" fxLayout="column" fxFlex>
                                <div class="assignment-text" fxLayout fxLayoutAlign="start center">
                                    @if (assignment.isNew) {
                                        <span class="new-box p-x-xs m-r-sm">{{ "assignments.new" | translate }}</span>
                                    }
                                    <span class="cipo--text-weight--bold title-assignment">
                                        {{ assignment.userName }}
                                    </span>
                                    <span class="m-l-xs info-assignment">({{ assignment.userEmail }})</span>
                                </div>
                                <div class="assignment-text info-assignment" fxLayout fxLayoutAlign="start center">
                                    <span class="cipo--text--ellipsed">{{ assignment.userOrgName }}</span>
                                    @if (assignment.isPending) {
                                        <span class="pending-box p-x-xs m-l-sm">
                                            {{ "assignments.pending" | translate }}
                                        </span>
                                    }
                                </div>
                                @if (!assignment.deleting) {
                                    <span
                                        class="assignment-text info-assignment"
                                        [title]="arrayControls[assignment.userId].value | assignments: roles">
                                        {{ "assignments.roles" | translate }}:
                                        {{ arrayControls[assignment.userId].value | assignments: roles }}
                                    </span>
                                } @else {
                                    <span class="warning-box info-assignment">
                                        {{ "assignments.removeWarning" | translate }}
                                    </span>
                                }
                            </div>
                            @if (userRateEnabled() && hasUpdate) {
                                <div class="assignment-number-field" fxFlex="none">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "assignments.rate" | translate }}</mat-label>
                                        <input
                                            [disabled]="disabledForm() || assignment.deleting"
                                            matInput
                                            type="number"
                                            min="0"
                                            oninput="
                                                this.value =
                                                    !isNaN(Number(this.value)) && Number(this.value) >= 0
                                                        ? Math.abs(this.value)
                                                        : null
                                            "
                                            [(ngModel)]="assignment.userRate"
                                            (ngModelChange)="somethingChange(assignment.userId)" />
                                    </mat-form-field>
                                </div>
                            }
                            @if (userAllocationEnabled() && hasUpdate) {
                                <div class="assignment-number-field" fxFlex="none">
                                    <mat-form-field appearance="outline">
                                        <mat-label>{{ "assignments.allocation" | translate }}</mat-label>
                                        <input
                                            [disabled]="disabledForm() || assignment.deleting"
                                            matInput
                                            type="number"
                                            min="0"
                                            oninput="
                                                this.value =
                                                    !isNaN(Number(this.value)) && Number(this.value) >= 0
                                                        ? Math.abs(this.value)
                                                        : null
                                            "
                                            [(ngModel)]="assignment.allocationHoursPerMonth"
                                            (ngModelChange)="somethingChange(assignment.userId)" />
                                    </mat-form-field>
                                </div>
                            }
                            <div
                                class="assignment-roles-field"
                                fxFlex="none"
                                fxLayout
                                fxLayoutAlign="start center"
                                fxLayoutGap="8px">
                                <cipo-select
                                    class="assignment-roles-select"
                                    fxFlex="grow"
                                    [control]="arrayControls[assignment.userId]" />
                                <button
                                    fxFlex="none"
                                    mat-icon-button
                                    [matMenuTriggerFor]="actionsMenu"
                                    [matMenuTriggerData]="{ assignment: assignment }"
                                    [disabled]="disabledForm()"
                                    [title]="'a11y.common.more' | translate"
                                    [attr.aria-label]="'a11y.common.more' | translate">
                                    <mat-icon aria-hidden="true">more_vert</mat-icon>
                                </button>
                            </div>
                        </div>
                    </cdk-virtual-scroll-viewport>
                }
            }
        </div>
    </div>
    <mat-menu #actionsMenu="matMenu">
        <ng-template matMenuContent let-assignment="assignment">
            @if (assignment.roleIds?.length > 1 && !assignment.deleting) {
                <button mat-menu-item (click)="openRoleOrderingDialog(assignment)">
                    <mat-icon aria-hidden="true">format_list_numbered</mat-icon>
                    <span>{{ "assignments.reorderRoles" | translate }}</span>
                </button>
            }
            @if (!assignment.deleting) {
                <button mat-menu-item (click)="deleteAssignment(assignment.userId)">
                    <mat-icon aria-hidden="true">delete</mat-icon>
                    <span>{{ "general.table.delete" | translate }}</span>
                </button>
            } @else {
                <button mat-menu-item (click)="restoreDeleteAssignment(assignment.userId)">
                    <mat-icon aria-hidden="true">restore</mat-icon>
                    <span>{{ "actions.restore" | translate }}</span>
                </button>
            }
        </ng-template>
    </mat-menu>
    <div
        fxFlex="none"
        fxLayoutAlign="end center"
        class="cipo--width--full p-a-sm"
        [class.cipo-bg--warning]="anyAssignmentsChanged()">
        @if (anyAssignmentsChanged()) {
            <button class="m-r-md" mat-button (click)="discardChanges()" [disabled]="disabledForm()">
                {{ "general.discard" | translate }}
            </button>
        }
        <button
            mat-raised-button
            class="m-r-xxl"
            color="primary"
            (click)="saveAssignments()"
            [disabled]="disabledForm()">
            {{ "general.update" | translate }}
        </button>
    </div>
</div>
